var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApyGraph1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 40,
    viewBox: "0 0 113 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 33.5067L4.85097 32.5608L7.09739 30.1959L14.1576 38L16.7249 35.7534L17.6876 33.5067L20.2549 35.7534L22.5014 34.2162L26.3523 36.2263L30.8452 30.3141H35.0171L37.5844 27.5945H39.5099L42.3981 24.1654L44.6446 23.5742L45.6073 28.5405L51.0628 21.3276L57.1602 22.6283L58.7648 23.5742L60.3694 17.4255L62.6158 20.1451H65.504L69.0341 13.1687L70.9596 14.7059L75.7734 15.1789L79.3034 17.0708L81.2289 17.8985L86.0426 6.54732L88.61 8.43923L90.5355 3L95.0282 11.2768L96.9538 12.1045L99.842 8.43898L100.805 15.1789L103.693 16.5978L105.298 19.3174L107.638 17.0708L110.061 13.1687L112 8.43923",
    stroke: "#45B549",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApyGraph1);
export default __webpack_public_path__ + "static/media/apyGraph1.4f0e7226dee21406d32212a7cd6aefe9.svg";
export { ForwardRef as ReactComponent };